/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React from 'react'
import { Modal } from 'antd-mobile'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
import { toString } from 'lodash'
import { clearCookie, getCookie, makeCookieKeyByUser, setCookie } from '@utils/utils'
import { COOKIE_KEYS } from '@constants/index'
// css
import { ModalBg } from '@styles/base.style'
import { Button } from '@styles/button.style'
import TelegramGuide from '@views/TelegramGuide'
import { AdvDialogStyle } from '@styles/modal'
import dayjs from 'dayjs'
// img
import TelegramImgBtnImg from '@assets/images/btn/telegram-modal-guide-btn.png'

const TelegramGuideBtnBanner = css`
  position: fixed;
  bottom: calc(176px + 20px);
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: auto;
  padding: 0 20px;
  border-radius: 0;
  background: none;
  img {
    width: 100%;
  }
  &.pc {
    padding: 0;
    width: 350px;
  }
`

const BetSuccessPopup: React.FC = () => {
  const { matchupStore, authStore, globalStore, componentStore } = useRootStore()
  const { visibleBetSuccess, betSuccessTodayInvisibleCookieKey } = globalStore
  const { isKeepCart } = matchupStore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onTodayInvisibleChange = () => {
    const cookieKey = betSuccessTodayInvisibleCookieKey || COOKIE_KEYS.BETTING_SUCCESS_POPUP_INVISIBLE_FOR_MATCHUP
    const key = makeCookieKeyByUser(cookieKey, authStore)
    const checked = getCookie(key)
    if (checked) {
      clearCookie(key)
    } else {
      const expires = dayjs().endOf('day')
      setCookie(key, toString(true), expires.toDate())
    }
  }

  const close = () => {
    globalStore.setVisibleBetSuccessPopup(false)
  }

  const clearBetStatus = () => {
    switch (betSuccessTodayInvisibleCookieKey) {
      case COOKIE_KEYS.BETTING_SUCCESS_POPUP_INVISIBLE_FOR_MATCHUP:
        matchupStore.clearCart()
        matchupStore.toggleBetSlipSiderCollapsed(true)
        matchupStore.toggleBetSlipBottomCollapsed(true)
        break
      case  COOKIE_KEYS.BETTING_SUCCESS_POPUP_INVISIBLE_FOR_COMPONENT:
        componentStore.cleanup()
        globalStore.setVisibleComponentBetSlip(false)
        break
    }
  }

  const onCloseClick = () => {
    if (!isKeepCart) {
      clearBetStatus()
    }

    close()
  }

  const onClickGoTelegramGuid = () => {
    globalStore.addGeneralPopupProperties(<TelegramGuide/>, '텔레그램 가이드', {
      wrapClassName: '', className: '', isScroll: true, custom: false, clsBtn: false,
    })
  }

  return (
    <Modal
      popup
      maskClosable={false}
      visible={visibleBetSuccess}
      animated={isMobile}
      animationType="slide-up"
      onClose={onCloseClick}
      css={AdvDialogStyle}
      className="new-slide-type title-only"
      title="베팅을 완료했습니다."
      wrapClassName="bet-success-modal"
    >
      <Button onClick={onClickGoTelegramGuid} css={TelegramGuideBtnBanner} className={!isMobile && 'pc'}>
        <img src={TelegramImgBtnImg} alt="이제 적중알림을 텔레그램으로 편하게 받자. 자세히 보기"/>
      </Button>
      {/*    /!*<input type="checkbox" id="check" onChange={onTodayInvisibleChange}/>*!/*/}
      {/*    /!*<label htmlFor="check" className="check-box">*!/*/}
      {/*    /!*  <span className="check-box--ico"/>*!/*/}
      {/*    /!*  <SpanWrap className="check-box--txt">오늘 그만 보기</SpanWrap>*!/*/}
      {/*    /!*</label>*!/*/}

      <Button className="single-btn" onClick={onCloseClick}>
        확인
      </Button>
      <ModalBg onClick={onCloseClick}/>
    </Modal>
  )
}

export default observer(BetSuccessPopup)

